import type { NavigationContent, NavigationItemContent, DRXNavigationContent } from "../types";
import experiment from "amplitude-experiment";

const PHONE_NUMBER = "888-634-1354";

const hideCompoundedSemaglutide = experiment.variant("hide-compounded-semaglutide").value === "on";

const NavContent: NavigationContent = {
  items: [
    ...(hideCompoundedSemaglutide
      ? []
      : [
          {
            label: "Injectable Weight Loss",
            href: "/clinics/weight-loss/compounded-semaglutide",
            items: [
              {
                label: "Compounded Semaglutide",
                href: "/clinics/weight-loss/compounded-semaglutide",
              },
            ],
          },
        ]),
    {
      label: "Erectile dysfunction",
      href: "/clinics/erectile-dysfunction",
      items: [
        {
          label: "Generic Viagra (Sildenafil)",
          href: "/clinics/erectile-dysfunction/generic-sildenafil",
        },
        {
          label: "Cialis",
          href: "/clinics/erectile-dysfunction/cialis",
        },
        {
          label: "Tadalafil (Generic Cialis)",
          href: "/clinics/erectile-dysfunction/generic-tadalafil",
        },
      ],
    },
    {
      label: "Migraine",
      href: "/clinics/migraine",
      items: [
        {
          label: "Sumatriptan",
          href: "/clinics/migraine/sumatriptan",
        },
        {
          label: "Rizatriptan",
          href: "/clinics/migraine/rizatriptan",
        },
        {
          label: "Zomig",
          href: "/clinics/migraine/zomig",
        },
        {
          label: "Zolmitriptan",
          href: "/clinics/migraine/zolmitriptan",
        },
      ],
    },
    {
      label: "Cold Sores",
      href: "/clinics/cold-sore",
      items: [
        {
          label: "Acyclovir",
          href: "/clinics/cold-sore/acyclovir",
        },
        {
          label: "Valacyclovir",
          href: "/clinics/cold-sore/valacyclovir",
        },
        {
          label: "Famciclovir",
          href: "/clinics/cold-sore/famciclovir",
        },
        {
          label: "Valtrex",
          href: "/clinics/cold-sore/valtrex",
        },
      ],
    },
    {
      label: "Yeast Infection",
      href: "/clinics/yeast-infection/fluconazole",
      items: [
        {
          label: "Fluconazole",
          href: "/clinics/yeast-infection/fluconazole",
        },
      ],
    },
    {
      label: "UTI",
      href: "/clinics/cystitis/nitrofurantoin",
      items: [
        {
          label: "Nitrofurantoin",
          href: "/clinics/cystitis/nitrofurantoin",
        },
      ],
    },
    {
      label: "Hair Loss",
      href: "/clinics/hair-loss/finasteride",
      items: [
        {
          label: "Finasteride",
          href: "/clinics/hair-loss/finasteride",
        },
      ],
    },
    {
      label: "Herpes",
      href: "/clinics/sexual-health/genital-herpes",
      items: [
        {
          label: "Acyclovir",
          href: "/clinics/sexual-health/genital-herpes/acyclovir",
        },
        {
          label: "Valacyclovir",
          href: "/clinics/sexual-health/genital-herpes/valacyclovir",
        },
        {
          label: "Famciclovir",
          href: "/clinics/sexual-health/genital-herpes/famciclovir",
        },
        {
          label: "Valtrex",
          href: "/clinics/sexual-health/genital-herpes/valtrex",
        },
      ],
    },
    {
      label: "Premature ejaculation",
      href: "/clinics/premature-ejaculation/sertraline",
      items: [
        {
          label: "Sertraline",
          href: "/clinics/premature-ejaculation/sertraline",
        },
      ],
    },
    {
      label: "Asthma",
      href: "/clinics/asthma/albuterol",
      items: [
        {
          label: "Albuterol",
          href: "/clinics/asthma/albuterol",
        },
        {
          label: "Ventolin",
          href: "/clinics/asthma/ventolin",
        },
        {
          label: "Proventil",
          href: "/clinics/asthma/proventil",
        },
      ],
    },
    {
      label: "Flu",
      href: "/clinics/flu/tamiflu",
      items: [
        {
          label: "Tamiflu",
          href: "/clinics/flu/tamiflu",
        },
      ],
    },
  ],
};

const SecondaryLinks: Array<NavigationItemContent> = [
  {
    label: "How it works",
    href: "/how-it-works",
  },
  {
    label: "Delivery",
    href: "/delivery",
  },
  {
    label: "FAQs",
    href: "/faq",
  },
  {
    label: "Reviews",
    href: "/reviews",
  },
  {
    label: "About",
    href: "/about-us",
  },
  {
    label: "Contact",
    href: "/contact",
  },
];

const callLinkContent = {
  label: "Call customer care",
  number: PHONE_NUMBER,
  href: `tel:${PHONE_NUMBER}`,
};

export const DRXNavContent: DRXNavigationContent = {
  primaryExpandedContent: NavContent,
  secondaryNavigationLinks: SecondaryLinks,
  callLinkContent,
};
